import {
  GUIDE_PAGE_LABEL,
  GUIDE_PAGE_LABEL_SUCCESS,
  GUIDE_PAGE_LABEL_FAIL,
} from "../Constants/GuidePageConstant";
const initialState = {
  elements: null,
  elementsStatus: false,
};

function guidePageReducer(state = initialState, action) {
  switch (action.type) {
    case GUIDE_PAGE_LABEL:
      return {
        ...state,
        elements: null,
        elementsStatus: true,
      };
    case GUIDE_PAGE_LABEL_SUCCESS:
      return {
        ...state,
        elements: action.payload,
        elementsStatus: false,
      };
    case GUIDE_PAGE_LABEL_FAIL:
      return {
        ...state,
        elements: null,
        elementsStatus: false,
      };

    default:
      return state;
  }
}

export default guidePageReducer;
